export default __webpack_public_path__ + "static/media/reporting_tool.0023c750.pdf";